import { render, staticRenderFns } from "./NomenclatureFilter.vue?vue&type=template&id=5f20a523"
import script from "./NomenclatureFilter.vue?vue&type=script&lang=ts"
export * from "./NomenclatureFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports